<template>
    <multiselect    v-if="Array.isArray(selectedEntities)"
                    class="hg-select"
                    :data-entities="JSON.stringify(entities,null,4)"
                    :data-filter="filterBy"
                    v-model="selectedEntities" 
                    :options="entities" 
                    :multiple="true" 
                    :taggable="$hisport.options.platform.CONFIGURATION.ALLOW_USER_INVITATION_BY_EMAIL && entityType==$hisport.entity_types.USER && validateEmail(lastSearch) && entities.length == 0" 
                    :searchable="true"
                    :loading.sync="isLoading"
                    :internal-search="false" 
                    :clear-on-select="false" 
                    :close-on-select="false" 
                    :options-limit="300" 
                    xblock-keys="['Tab', 'Enter']"
                    xlimit="1" 
                    open-direction="bottom"
                    :max-height="600" 
                    :show-no-results="false" 
                    :hide-selected="true" 
                    :tag-placeholder="$options.filters.i18n('INVITE_USER_BY_MAIL')" 
                    xplaceholder="$options.filters.i18n('SEARCH_OR_INVITE_USER')" 
                    label="name" 
                    track-by="id" 
                    @search-change="fetchEntities"
                    @input="update"
                    @remove="update"
                    @tag="addTag">
        <template slot="noOptions">
            <div v-if="isLoading">
                <font-awesome-icon :icon="['fas','futbol']" spin/>
            </div>
            <div v-else>
                <font-awesome-icon :icon="['fas','info-circle']"/>&nbsp;
                <span v-i18n="(entityType==$hisport.entity_types.USER)?'NO_USER_OPTIONS':'NO_OPTIONS'"  class="text-muted"/>
            </div>
        </template>
        <template slot="noResult">
            <div v-if="isLoading">
                <font-awesome-icon :icon="['fas','futbol']" spin/>
            </div>
            <span v-i18n="(entityType==$hisport.entity_types.USER)?'NO_USER_RESULT':'NO_RESULT'"  class="error" v-else/>
        </template>
        <template slot="tag" slot-scope="props">
            <div class="tag-user-item invitation"  v-if="props.option.isTag">
                <div class="user-icon" >
                    <font-awesome-icon :icon="['fas','envelope']"/>
                    <!-- <img src="/images/invite.png"/> -->
                </div>
                <div class="user-body">
                    <span class="user-type" :class="{error: !validateEmail(props.option.email)}">{{props.option.email}}</span>
                </div>
                <a class="user-remove" href="javascript: void 0" @click="props.remove(props.option)">
                    <font-awesome-icon :icon="['fas','times']"/>
                </a>
            </div>
            
            <div class="tag-user-item" v-else>
                <div class="user-icon" >
                    <img :src="$hisport.absolute(props.option.logo, {default:'/images/user_default.png', w: 64, h:64})" v-img-fallback="'/images/user_default.png'"/>
                </div>
                <div class="user-body">
                    <span class="user-type">{{props.option.name}}</span>
                </div>
                <a class="user-remove" href="javascript: void 0" @click="props.remove(props.option)">
                    <font-awesome-icon :icon="['fas','times']"/>
                </a>
            </div>
            
        </template>
        <template slot="option" slot-scope="props">
            <div class="user-item invitation"
                v-if="props.option.isTag" v-show="$hisport.options.platform.CONFIGURATION.ALLOW_USER_INVITATION_BY_EMAIL">
                <div class="user-icon" >
                    <!-- <img src="/images/invite.png"/> -->
                    <font-awesome-icon :icon="['fas','envelope']"/>
                    <!-- <font-awesome-icon :icon="['fas','exclamation-triangle']"/> -->
                </div>
                <div class="user-body">
                    <span class="user-type">{{props.option.label}}</span>
                    <!-- <small class="user-suggestion-mail" v-i18n="'SUGGESTION_VALID_EMAIL'" /> -->
                </div>
            </div>
            
            <div class="user-item" v-else>
                <div class="user-icon" >
                    <img :src="$hisport.absolute(props.option.logo, {default:'/images/user_default.png', w: 64, h:64})" v-img-fallback="'/images/user_default.png'"/>
                </div>
                <div class="user-body">
                    <span class="user-type">{{props.option.name}}</span>
                </div>
            </div>
        </template>
    </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import _ from "lodash"
import Multiselect from 'vue-multiselect'
import { HELPERS }  from 'morpheos.hisport.vueplugin';
export default {
    components: {
        Multiselect
    },
    props: {
        value:      { type: Array,  default: function(){ return []; } },
        filterBy:   { type: Object, default: function(){ return null; } },
        entityType: { type: Number, default: -1 },
        onlyByEmail:  { type: Boolean, default: false}
    },
    mounted(){
        this.init();
    },
    data(){
        return {
            selectedEntities: [],
            entities: [],
            isLoading: false,
            lastSearch: ""
        }
    },
    methods:{
        // validateEmail: function(mail){
        //     return (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail));
        // },

        validateEmail: function(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        addTag: function(email){
            if(this.validateEmail(email) && this.$hisport.options.platform.CONFIGURATION.ALLOW_USER_INVITATION_BY_EMAIL){
                var preUser = this.entities.find(function(x){
                    return x.email && x.email.toLowerCase() == email.toLowerCase()
                })
                if(preUser){
                    this.selectedEntities.push(preUser)
                }else{
                    var usr = {
                        isTag: true,
                        id: email,
                        email: email,
                        name: email
                    }
                    this.selectedEntities.push(usr);
                }
                this.update()
            }
        },
        update: function(){
            // if(!Array.isArray(e)) return console.error("INVALID OBJECT", e);
            var val = this.selectedEntities.map(function(x){ return x.id; })
            this.$emit('input', val);
        },
        init: function(){
            if(Array.isArray(this.value) && this.value.length > 0 ){
                var self = this;
                var valueIds = this.value.filter(function(x){ return typeof x != "string"; })
                var valueEmails = this.value.filter(function(x){ return typeof x == "string"; })
                self.entities = [];
                self.selectedEntities = valueEmails.map(function(email){
                    return { isTag: true, id: email, name:email, email: email}
                });
                
                if(valueIds.length==0)
                    return
                this.$hisport.datacontext.entity.getAll({
                    page_index: 0, 
                    page_size: 100,
                    column_filters: HELPERS.extend(this.filterBy, {
                        id: {$in: valueIds }, 
                        entity_type: this.entityType
                    })
                })
                .then(function(result){
                self.entities = self.entities.concat(result.entries);  
                self.selectedEntities = self.selectedEntities.concat(result.entries);
                })
                .catch(function(error){
                    console.error(error)
                });
            }
        },
        fetchEntities: _.debounce(function(search){
            var self = this;
            if(!search || typeof(search) != "string" || search.length < 2) return;
            var options = {
                $or: [
                    {name: new RegExp("/?/*" + search + "/?/*", "gi")},
                    {email: new RegExp("/?/*" + search + "/?/*", "gi")},
                ], 
                entity_type: this.entityType
            }
            if(this.entityType == this.$hisport.entity_types.USER && this.onlyByEmail){
                if(!this.validateEmail(search)) return console.log("Aborted", search, "is not a valid email address")
                options = {
                    email: search.toLowerCase(),
                    entity_type: this.entityType
                }
            }
            this.lastSearch = search;
            this.isLoading = true;
            self.entities.splice(0);
            
            //loading(true);
            this.$hisport.datacontext.entity.getAll({
                    page_index: 0, 
                    page_size: 100,
                    column_filters: HELPERS.extend(this.filterBy, options)
                })
                .then(function(result){
                    result.entries.forEach(function(u){
                        if(!self.entities.find(x=>x.id == u.id)){
                            self.entities.push(u);
                        }
                    })
                    self.entities.sort(function(a,b){
                        return a.name.localeCompare(b.name);
                    });
                    self.isLoading = false;
                    //loading(false);
                })
                .catch(function(error){
                    console.error(error)
                })
        }, 500, true),
    },
    watch:{
        value: function(){
            this.init();
        }
    }
}
</script>
<style>
.user-select{position:relative;}
.user-item{display:flex;padding:4px 0 0 0;align-content: center; align-self: center;color: #333;}
.tag-user-item{ display:inline-flex;padding:0px 2px;
                align-content: center; align-self: center;
                background:var(--light-grey);
                height:26px;
                margin:0 2px;border-radius:var(--border-radius);}
.user-item.invitation svg{margin:9px;}
.tag-user-item img{border-radius: var(--border-radius);width:26px;height:26px;padding:2px;margin-right:0px}
.user-item img{border-radius: var(--border-radius);width:32px;height:32px;padding:2px;margin-right:0px}
.user-item .user-body{font-size:16px;font-weight:normal;color:inherit;padding: 9px 0 0 0;}
.tag-user-item .user-body{font-size:12px;font-weight:normal;color:inherit;padding: 6px 0 0 0;}
.tag-user-item .user-remove{
    padding:6px;
}
.user-select .vs__deselect{margin-right:5px;}
.user-select,
.user-select .vs__dropdown-toggle{min-height:42px}
.user-select,
.user-select .vs__dropdown-toggle,
.user-select .vs__selected-options,
.user-select .vs__selected{padding: 0;}
.user-select .vs__dropdown-option{padding:0;}
.user-select .vs__selected-options{flex-wrap: wrap;padding: 0 0 5px;}
.user-select .vs__selected{max-height:32px;}
.v-select.hg-select .vs__dropdown-toggle{height: auto;}
.user-select .vs__dropdown-toggle{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(60,60,60,.26);
  border-radius: 4px;
  color: #666;
}
.text-muted{
    color: rgba(0,0,0,.7);
    font-style:italic;
}
</style>